module.exports = __webpack_public_path__ + "static/media/introduce.7e0e1c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程星享/introduce.png
// module id = 692
// module chunks = 0